import * as React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

interface SkeletonChartProps {
  /** Chart area height in px. Defaults to 300 to match the analytics chart wells. */
  height?: number;
  /** When true, renders a small inline legend row above the chart placeholder. */
  legend?: boolean;
  /** Number of legend chips to render when `legend` is true. */
  legendItems?: number;
}

/**
 * SkeletonChart — placeholder for a Recharts chart while data loads. Mimics
 * the visual rhythm of a stacked-bar dashboard chart so the layout doesn't
 * jump when real data arrives.
 */
const SkeletonChart: React.FC<SkeletonChartProps> = ({
  height = 300,
  legend = false,
  legendItems = 3
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      {legend && (
        <Stack direction="row" spacing={2} sx={{ mb: 1.5 }}>
          {Array.from({ length: legendItems }).map((_, i) => (
            <Skeleton key={i} variant="rounded" width={90} height={20} />
          ))}
        </Stack>
      )}
      <Skeleton variant="rounded" width="100%" height={height} animation="wave" />
    </Box>
  );
};

export default SkeletonChart;
